module.exports = __webpack_public_path__ + "img/icon-cooking.badae5a6.png";